import styled from "styled-components/macro";
import { Button, WidgetCard } from "../../../../components";
import { media } from "../../../../utils";

export const TransferenciaTitularidadeCard = styled(WidgetCard)`
  max-width: none;
  height: max-content;
  & > .Card__Body {
    color: inherit !important;
  }
`;

export const CardContainer = styled.div({
  [media.lg()]: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
});

export const BlockContent = styled.div`
  border-bottom: 1px solid;
  border-bottom-color: ${({ theme }) => theme.color.neutral["04"]};
  padding: 32px 0;
`;

export const ButtonForm = styled(Button)`
  width: 100%;
`;
